import jump from 'jump.js';

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

// General jump
$(document).ready(function() {

  if(window.location.hash)
  {
    callJump();
  }

  $(window).on('hashchange', function() {

    callJump();

  });

})

function callJump() {

  if($('.jump-'+window.location.hash.substr(1)).length)
  {
      let px = $('.jump-'+window.location.hash.substr(1)).css('margin-top');

      if(window.location.hash.substr(1) == 'up') {

        jump('.jump-'+window.location.hash.substr(1), {
          duration: 1000,
          easing: easeInOutQuad,
          offset: -200
        });

      } else {

        jump('.jump-'+window.location.hash.substr(1), {
          duration: 1000,
          easing: easeInOutQuad,
          offset: -($('.g--header').height() + parseInt(px.substr(0, px.length - 2)))
        });

      }

      let backLink = window.location.pathname.split('#')[0];
      window.history.pushState(backLink, null, backLink);
  }

}
